<app-breadcrumb [title]="'Documentos PESV'" [items]="['Implementación', 'Listado']" [active_item]="'Listado Maestro'">
</app-breadcrumb>

<!-- Icono de ordenamiento reutilizable -->
<ng-template #sortIcon let-col>
  <i class="fa ms-1 small" [ngClass]="sortColumn === col
    ? (sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down')
    : 'fa-sort text-primary opacity-50'"></i>
</ng-template>

<div class="container-fluid">
  <div class="card shadow-sm border rounded-3 listado-maestro">

    <!-- Encabezado -->
    <div class="card-header bg-white d-flex flex-wrap align-items-center justify-content-between gap-3 py-3">
      <div>
        <h5 class="mb-0 fw-semibold">Documentos maestros PESV</h5>
        <small class="text-primary">Listado maestro de documentos, retención y estado de vigencia</small>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <button type="button" class="btn btn-sm btn-outline-secondary" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel()">
          <i class="icofont icofont-file-excel me-1"></i>Excel
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" ngbTooltip="Exportar a PDF"
          (click)="exportarPDF()">
          <i class="icofont icofont-file-pdf me-1"></i>PDF
        </button>
        <button type="button" class="btn btn-sm btn-primary" (click)="nuevoDocumento()">
          <i class="icofont icofont-plus-circle me-1"></i>Nuevo documento
        </button>
      </div>
    </div>

    <div class="card-body">

      <!-- Contador y búsqueda -->
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
        <div class="text-primary" *ngIf="!cargando">
          <strong class="text-body fs-6">{{ documentosFiltrados?.length }}</strong>
          {{ documentosFiltrados?.length === 1 ? 'documento' : 'documentos' }}
          <span *ngIf="searchText && documentos.length !== documentosFiltrados.length">de {{ documentos.length }}</span>
        </div>

        <div class="input-group ms-md-auto buscador">
          <span class="input-group-text bg-transparent"><i class="fa fa-search text-primary"></i></span>
          <input type="text" class="form-control border-start-0" placeholder="Buscar por código, nombre, pilar o estado"
            aria-label="Buscar documentos" [(ngModel)]="searchText" (input)="filtrarDocumentos(); page = 1" />
        </div>
      </div>

      <div class="table-responsive border rounded-3">

        <!-- Skeleton -->
        <table *ngIf="cargando" class="table mb-0">
          <thead class="table-light">
            <tr>
              <th *ngFor="let col of [1,2,3,4,5,6,7,8]"><div class="skeleton skeleton-th"></div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of [].constructor(5)">
              <td *ngFor="let col of [1,2,3,4,5,6,7,8]"><div class="skeleton skeleton-td"></div></td>
            </tr>
          </tbody>
        </table>

        <!-- Tabla -->
        <table *ngIf="!cargando" class="table table-hover align-middle mb-0" id="tblImplementacion">
          <thead class="table-light">
            <tr>
              <th class="sortable" (click)="sortData('codigo')">
                Código<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'codigo' }"></ng-container>
              </th>
              <th class="sortable" (click)="sortData('nombre')">
                Nombre<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'nombre' }"></ng-container>
              </th>
              <th class="sortable" (click)="sortData('tipo_documental.nombre')">
                Tipo documental<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'tipo_documental.nombre' }"></ng-container>
              </th>
              <th class="sortable" (click)="sortData('pilar.nombre')">
                Pilar<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'pilar.nombre' }"></ng-container>
              </th>
              <th class="sortable" (click)="sortData('EstadoDocumentosImplementacion.nombre')">
                Estado<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'EstadoDocumentosImplementacion.nombre' }"></ng-container>
              </th>
              <th class="sortable text-end" (click)="sortData('retencion')">
                Retención<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'retencion' }"></ng-container>
              </th>
              <th class="sortable" (click)="sortData('fecha_creacion')">
                Creación<ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'fecha_creacion' }"></ng-container>
              </th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let doc of documentosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }"
              [class.text-primary]="!doc.activo">
              <td><span class="badge badge-light-info font-monospace">{{ doc.codigo }}</span></td>
              <td class="fw-medium text-uppercase">{{ doc.nombreDocumento?.nombre_documento }}</td>
              <td>{{ doc.tipoDocumentalImplementacionData?.nombre || '-' }}</td>
              <td>{{ doc.pilarData?.nombre || '-' }}</td>
              <td>
                <span class="badge rounded-pill" [ngClass]="claseBadgeEstado(doc.EstadoDocumentosImplementacion?.id)">
                  {{ doc.EstadoDocumentosImplementacion?.nombre || '-' }}
                </span>
              </td>
              <td class="text-end text-nowrap">{{ doc.retencion ? doc.retencion + ' años' : '-' }}</td>
              <td class="text-nowrap">{{ doc.fecha_creacion | date: 'dd/MM/yyyy' }}</td>
              <td class="text-center text-nowrap">
                <button type="button" class="btn btn-sm btn-light" ngbTooltip="Editar" aria-label="Editar documento"
                  (click)="editarDocumento(doc)">
                  <i class="icon-pencil-alt text-primary"></i>
                </button>
                <button type="button" class="btn btn-sm btn-light ms-1"
                  [disabled]="!puedeCambiarEstado(doc)"
                  [ngbTooltip]="puedeInactivar(doc) ? 'Inactivar' : puedeActivar(doc) ? 'Activar' : 'Solo se activa en BORRADOR o se inactiva en VIGENTE'"
                  [attr.aria-label]="(puedeInactivar(doc) ? 'Inactivar ' : 'Activar ') + doc.nombre"
                  (click)="cambiarEstadoDocumento(doc, !puedeInactivar(doc))">
                  <i [ngClass]="puedeInactivar(doc) ? 'icon-close text-danger' : 'icon-check-box text-success'"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="documentosFiltrados.length === 0">
              <td colspan="8" class="text-center text-primary py-5">
                <i class="fa fa-folder-open fa-2x mb-2 d-block"></i>
                <p class="fw-semibold text-body mb-1">No hay documentos para mostrar</p>
                <p class="mb-0" *ngIf="searchText; else sinDocumentos">
                  Ningún documento coincide con "{{ searchText }}".
                </p>
                <ng-template #sinDocumentos>
                  <p class="mb-0">Crea el primer documento maestro para empezar el listado.</p>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pie -->
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3">
        <div class="d-flex align-items-center gap-2 text-primary">
          <label for="pageSize" class="mb-0">Mostrar</label>
          <select id="pageSize" class="form-select form-select-sm w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span>por página</span>
        </div>

        <div class="paginador-personalizado">
          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

    </div>
  </div>
</div>